/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/core/metadata/dataTransfer/resolvers/default/text/component/unitprice"/>

import * as financeComponent from "Core/Medius.Core.Web/Scripts/Medius/core/metadata/dataTransfer/resolvers/default/text/component/financeComponent";
import * as settingsProvider from "Core/Medius.Core.Web/Scripts/Medius/core/settingsProvider";

export const resolver = financeComponent.create("Medius.Core.DTOs.UnitPriceDto", settingsProvider.getUnitPriceDisplayResolution);
